import {
  ActionStore,
  createAction,
  KeyStore,
  on, ParamsStore,
  RemoteObjectStore,
  SOFTLINE_SERVICE_UUID,
  SOFTLINE_STORE_OBJECT_SERVICE,
  StoreBuilder,
  StoreFeature,
  SyncedRemoteObjectStore
} from '@softline/core';
import {CouponType} from '../data/coupon-type';
import {SOFTLINE_SERVICE_COUPON_CARD_TRANSACTION} from '../coupon-app.shared';

export interface State extends RemoteObjectStore.State<CouponType> { }

class CouponStoreExtension {
  static actions = {
    transaction: createAction<State, {amount: number, action: 'CHARGE' | 'DEBIT', code: number | undefined }, any>('transaction')
  };

  static feature: Partial<StoreFeature<State>> = {
    actions: [
      on(CouponStoreExtension.actions.transaction, async ({featureName, commit, params, injector}) => {
        const service = injector.get(SOFTLINE_SERVICE_COUPON_CARD_TRANSACTION);
        const token = injector.get(SOFTLINE_SERVICE_UUID)();
        commit(featureName, KeyStore.mutations.add, token);
        commit(featureName, ParamsStore.mutations.add, {key: token, params});

        const observable = service.create(params, undefined);
        const result = await ActionStore.handleObservableActionState(
          observable, featureName, commit, CouponStoreExtension.actions.transaction.name, token
        ).toPromise();
        commit(featureName, SyncedRemoteObjectStore.mutations.set, result);
        return result;
      })
    ]
  };
}

export const CouponStore = new StoreBuilder(RemoteObjectStore.create<CouponType>())
  .add(KeyStore)
  .add(ParamsStore)
  .add(CouponStoreExtension)
  .value;
